import {PlatformService} from './../../../../services/platform';
import {Component, trigger, state, style, transition, animate} from '@angular/core';
import {NavController, ModalController} from 'ionic-angular';
import {SearchBeautyBarPage} from './search-bar/search-bar';
import {SessionService} from '../../../../services/session';
import {LocationsService} from '../../../../services/locations';
import {BeautyClassesService} from '../../../../services/beauty-classes';
import {BeautyClassPage} from '../../shared/beauty-class/beauty-class';
import {BeautyStudioPage} from '../../shared/beauty-studio/beauty-studio';
import {BeautyFiltersPage} from './beauty-filters/beauty-filters';
import {BeautyStudiosService} from '../../../../services/beauty-studios';
import {BeautyFiltersService} from '../../../../services/beauty-filters';
import {BeautyMapService} from '../../../../services/beauty-map';

@Component({
  selector: 'page-find-beauty-class',
  templateUrl: 'find-beauty-class.html',
  animations: [
    trigger('panel', [
      state(
        'in',
        style({
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({
          transform: 'translateX(-100%)',
        }),
        animate(300),
      ]),
      transition('* => void', [
        animate(
          300,
          style({
            transform: 'translateX(100%)',
          })
        ),
      ]),
    ]),
  ],
})
export class FindBeautyClassPage {
  classPage = BeautyClassPage;
  studioPage = BeautyStudioPage;
  currentDate = 0;
  gymInMap: any = null;
  studioChosen = false;
  hasStarted = false;
  classTypeFadeOut = false;

  studioInfo: any = {
    name: '',
    latitude: '',
    longitude: '',
    address: '',
    gym_pictures: [],
  };

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public classesService: BeautyClassesService,
    public studiosService: BeautyStudiosService,
    public sessionService: SessionService,
    public platformService: PlatformService,
    public filtersService: BeautyFiltersService,
    public mapService: BeautyMapService,
    public locationsService: LocationsService
  ) {
    classesService.initiateClasses();

    classesService.loadAll(
      true,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      sessionService.user ? sessionService.user.city_id : null,
      null,
      null,
    );

    filtersService.showMap = false;
  }

  //Changes date when clicking in the date picker
  changeDate(event) {
    this.currentDate = event.date;
  }

  // Opens Filters
  presentFiltersModal() {
    let modal = this.modalCtrl.create(BeautyFiltersPage);
    modal.onDidDismiss((data) => {
      if (data) {
        this.doRefresh();
      }
    });
    modal.present();
  }

  // Opens Search Bar
  presentSearchBarModal() {
    let modal = this.modalCtrl.create(SearchBeautyBarPage, {searchText: this.mapService.searchText});
    modal.onDidDismiss((gym) => {

      if (gym) {
        this.gymInMap = gym;
        this.mapService.searchText = gym.name;
        this.filtersService.queryParams.latitude = gym.latitude;
        this.filtersService.queryParams.longitude = gym.longitude;
        this.filtersService.queryParams.radius = '1';
        this.filtersService.queryParams.city = gym.city.id;
        this.filtersService.queryParams.gym = [gym.id];
        this.filtersService.queryParams.services = [];
        this.filtersService.queryParams.zones = [];
        this.filtersService.queryParams.categories = [];
        this.doRefresh();
      } else {
        this.filtersService.queryParams.gym = undefined;
      }

      this.doRefresh();

    });
    modal.present();
  }

  //resets search filter
  cancelSearch() {
    this.removeStudio();
    this.mapService.searchText = '';
    this.mapService.lastSelectedMarker = null;
    this.filtersService.queryParams.latitude = null;
    this.filtersService.queryParams.longitude = null;
    this.filtersService.queryParams.radius = null;
    this.doRefresh();
  }

  //resets classType
  cancelClassType() {
    this.classTypeFadeOut = true;
    this.filtersService.queryParams.categories = [];
    this.filtersService.queryParams.services = [];
    this.doRefresh();
    //timeout must be ~= to animation time
    setTimeout(() => {
      this.classTypeFadeOut = false;
      this.filtersService.classType = '';
    }, 300);
  }

  //remove Studio
  removeStudio() {
    if (this.mapService.lastSelectedMarker && this.mapService.lastSelectedMarker.name === this.mapService.searchText) {
      this.gymInMap = null;
      this.studioChosen = false;
      if (!this.studioInfo.name) {
        this.studioInfo = 'x';
      }
      this.studioInfo = null;
    }
  }

  // Goes to a class in class list
  goToClass(classInfo) {
    if (classInfo.schedule.lesson_availability > classInfo.schedule.reservations) {
      this.navCtrl.push(this.classPage, {classInfo}, {updateUrl: true});
    }
  }

  // Displays studio banner in map
  displayStudio(event) {
    this.studioChosen = false;
    if (!event.studioInfo) {
      return;
    }
    setTimeout(() => {
      this.studioChosen = true;
    }, 1);
    this.studioInfo = event.studioInfo;
    this.gymInMap = event.studioInfo;
    this.mapService.searchText = event.studioInfo.name;
    this.filtersService.queryParams.latitude = event.studioInfo.latitude;
    this.filtersService.queryParams.longitude = event.studioInfo.longitude;
    this.filtersService.queryParams.radius = '1';
  }

  // Goes to a studio in map
  goToStudio() {
    // need to remove map in order to open map in new page
    this.filtersService.hideMapForShowingOnStudio = true;
    // for some reason cant open studioPage with map if I dont set a timeout of >=1 ms
    setTimeout(() => {
      this.navCtrl.push(this.studioPage, {studioInfo: this.studioInfo});
    }, 1);
  }

  // Loads next 30 clases
  loadNext(infiniteScroll) {
    this.classesService
      .loadNext(
        this.currentDate,
        false,
        this.filtersService.queryParams.touched ? this.filtersService.queryParams.structure.lower : null,
        this.filtersService.queryParams.touched ? this.filtersService.queryParams.structure.upper : null,
        this.filtersService.queryParams.latitude,
        this.filtersService.queryParams.longitude,
        this.filtersService.queryParams.radius,
        this.filtersService.queryParams.services,
        this.filtersService.queryParams.gym,
        this.filtersService.queryParams.city,
        this.filtersService.queryParams.zones,
        this.filtersService.queryParams.categories
      )
      .then(() => {
        infiniteScroll.complete();
      })
      .catch((err) => {
        this.sessionService.reportError('findClassPage', 'loadNext()', err);
      });
  }

  // Restarts classes and loads first 30 classes
  doRefresh(refresher?) {
    this.classesService.initiateClasses();
    this.classesService.loadAll(
      true,
      this.filtersService.queryParams.touched ? this.filtersService.queryParams.structure.lower : null,
      this.filtersService.queryParams.touched ? this.filtersService.queryParams.structure.upper : null,
      this.filtersService.queryParams.latitude,
      this.filtersService.queryParams.longitude,
      this.filtersService.queryParams.radius,
      this.filtersService.queryParams.services,
      this.filtersService.queryParams.gym,
      this.filtersService.queryParams.city,
      this.filtersService.queryParams.zones,
      this.filtersService.queryParams.categories
    );
    if (refresher) {
      refresher.complete();
    }
  }

  showMap() {
    this.filtersService.showMap = !this.filtersService.showMap;
    this.filtersService.hideMapForShowingOnStudio = false
  }

  //Hides map when leaving
  ionViewWillLeave() {
    this.filtersService.hideMapForShowingOnStudio = true;
  }

  //Shows map when entering
  ionViewWillEnter() {
    this.filtersService.hideMapForShowingOnStudio = false;
  }

  ionViewDidEnter() {
    this.hasStarted = true;
  }

  ionViewDidLoad() {
    window['page'] = 'FindBeautyClassPage'; // for GA
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/beauty/find-beauty-class/find-beauty-class.ts